'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_7fc2511b = {"dots":"PaginationButton_module_dots__66040bf9","selected-page":"PaginationButton_module_selectedPage__66040bf9"};
require("../../../assets/cjs/components/Table/src/PaginationButton~DD2DXLO1.css");

exports.default = modules_7fc2511b;
//# sourceMappingURL=PaginationButton.module.less.js.map
